<template>
  <div>
    <div class="history-log-and-memo">
      <div class="history-memo-item"
           v-for="(item, idx) in memoLogs"
           :key="'history-memo'+idx">
        <div style="margin-bottom:2px;">
          <span style="margin-right:8px;" :style="msgStyle(item.msg_type)" v-if="item.msg_type>0">{{ msgType(item.msg_type) }}</span>
          <span style="margin-right:8px;">{{ item.created_time }}</span>
          <span>{{ item.author }}</span>
        </div>
        <span style="display:inline-block;white-space:pre-line;">{{ item.content }}</span>
      </div>
    </div>

    <div style="margin-top: 8px">
      <span class="select">
        <select v-model="msg_type" @change="e=>msg_type=parseInt(e.target.value)">
          <option v-for="(item,idx) in msgTypeArr" :key="`item-${idx}`" :value="item.value">{{ item.label }}</option>
        </select>
      </span>
      <textarea class="textarea"
                :placeholder="placeholder"
                style="margin-top:8px"
                :value="newMemo"
                @keyup.enter="$emit('onClickHistoryBtn',{'content': newMemo, 'msg_type': msg_type})"
                @input="e => newMemo = e.target.value">
      </textarea>
      <div class="flex" style="justify-content: flex-end; padding-top: 8px;">
        <button class="button is-primary"
                @click.stop.prevent="$emit('onClickHistoryBtn', {'content': newMemo, 'msg_type': msg_type})">입력
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {

    name: 'AdminLogMemo1',

    props: {
      memoLogsValue: {
        type: Array,
        required: false,
      },
      newMemoValue: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      }
    },

    data() {
      return {
        memoLogs: [],
        newMemo: '',
        msgTypeArr: [
          {label:'내부메모', value:1},
          {label:'전화', value:2},
          {label:'이메일', value:3},
        ],
        msg_type: 1
      }
    },

    created() {
      this.memoLogs = this.memoLogsValue;
      this.newMemo = this.newMemoValue;
    },
    methods: {
      msgStyle(type) {
        let style = {};
        if(type===1) {
          style.color = '#2196f3';
        } else if(type===2) {
          style.color = '#FF3B3B';
        } else if(type===3) {
          style.color = '#FF6600';
        }
        return style;
      },
      msgType(type) {
        let text = '';
        if(type===1) {
          text = '내부 메모';
        } else if(type===2) {
          text = '전화';
        } else if(type===3) {
          text = '이메일';
        }
        return text;
      }
    },

    watch: {
      memoLogsValue(n) {
        this.memoLogs = n;
      },
      newMemoValue(n) {
        this.newMemo = n;
      },
      memoLogs(n) {
        this.$emit('update:memoLogsValue', n);
      },
      newMemo(n) {
        this.$emit('update:newMemoValue', n);
      },
    }

  }
</script>

<style lang="stylus" type="stylus" scoped>

  .history-log-and-memo
    width 100%
    height 186px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto

  .history-memo-item
    width 100%
    margin-bottom 12px

</style>
